import { useParams } from 'react-router-dom';
import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';
import SectionWrapper from '../../components/SectionWrapper/SectionWrapper';
import PaymentForm from '../../modules/payable/payments/components/PaymentForm';

const RegisterPaymentPage = () => {
  const { payableId } = useParams();

  const parsedPayableId = payableId ? Number(payableId) : undefined;

  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <SectionWrapper>
        <PaymentForm
          key={parsedPayableId}
          PayableId={parsedPayableId}
        />
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default RegisterPaymentPage;
